export default {"src":"/_next/static/media/payment-methods.63b8edf3.svg","height":32,"width":311,"blurWidth":0,"blurHeight":0};